// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"981bd793","680":"0a9f7de1"}[chunkId] + ".chunk.js";
};